import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { ModelList } from '../../../components/PaginatedList/ModelList';


// Redux
import { searchAlbum, restoreAlbum, createAlbum, getAlbum } from '../Album/redux/album.actions';
import { FullAlbums } from '../Album/redux/album.selectors';
import { FullLibraries } from './redux/library.selectors';
import { hasAccess, TERM_ALBUM_PLURAL, TERM_LIBRARY, TERM_RECENT } from '../../services/CaptureCollabService';
import { NewContent } from '../../../components/Content/NewContent';
import { HorizontalStack, SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { AlbumList } from '../Album/AlbumList';
import { LibraryNavigation } from './LibraryNavigation';
import { useParams } from 'react-router-dom';
import { getLibrary } from './redux/library.actions';
import { Photostream } from '../Photostream/Photosteam';
import { StyledH3, StyledH6, StyledP } from '../../../styles/StyledHTML';
import { StyledButton } from '../../../styles/matieralui/Button';
import { DashedSurface, Uploader } from '../Photostream/Uploader';
import { useAnalytics } from '../../../modules/Analytics/AnalyticsService';
import { Role } from '../../../redux/Auth/auth.selectors';
import { useMyPermissions } from '../Permission/redux/permissions.actions';
import { NoPermissions } from '../Permission/NoPermissions';
import { RouteBreadCrumbs } from '../../../routes';
import { dispatchClearState } from '../../../redux/utils';
import { TopLevelNavigation } from '../../components/Dashboard/TopLevelNavigation';
import { EmptyMessage } from '../../components/Empty/EmptyMessage';
import { IconUpload, IconView } from '../../Icons';

export const PageUpload = () => {

    // New Modal
    const dispatch = useDispatch();
    const storeLibraries = FullLibraries();
    const storeAlbums = FullAlbums();
    const { id, albumId } = useParams();
    const [activeItem, setActiveItem] = useState(null);
    const [activeAlbum, setActiveAlbum] = useState(null);

    const [filters, setFilters] = useState({});
    const { trackEvent } = useAnalytics();

    const currentUserRole = Role();
    const { permissions, hasPermission, getPermissionRole, permissionChecked } = useMyPermissions();
    const [noAccess, setNoAccess] = useState(false);
    const [myRole, setMyRole] = useState(null);


    // --------------------------
    // Effects
    // --------------------------
    // Get This Item
    useEffect(() => { dispatch(getLibrary(id)) }, [id]);
    useEffect(() => {
        if (!albumId) {
            setActiveAlbum(null);
            return;
        }
        dispatch(getAlbum(albumId))
    }, [albumId]);

    // Set Active Item
    useEffect(() => {
        if (storeLibraries?.activeItem) setActiveItem(storeLibraries.activeItem);
    }, [storeLibraries.activeItem, storeLibraries])

    // Set Active Item
    useEffect(() => {
        if (storeAlbums?.activeItem && albumId) {

            setActiveAlbum(storeAlbums.activeItem);
        }
    }, [storeAlbums.activeItem, storeAlbums])

    // Check Permissions
    useEffect(() => {


        if (hasPermission('Library', id)) {
            const r = getPermissionRole('Library', id);
            setNoAccess(false);
            setMyRole(r);
        } else {

            setNoAccess(true);
        }

    }, [permissions])


    // --------------------------
    // Renders
    // --------------------------
    const renderTopBarChildren = () => {


        return (
            <SmartContainer flex align="center" justify="flex-end">
                <StyledButton variant='contained' color="error" onClick={() => dispatch(push(`/library/${id}`))}>Cancel Upload</StyledButton>
            </SmartContainer>
        )

    }

    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
        // return (<LibraryNavigation libraryId={id} />)
    }

    const handleUploadComplete = (tags) => {

        // Track
        const trackArgs = {
            category: 'User',
            action: 'UPLOAD',
            Libraries: [`${id}`],
            notify: true
        }
        // Related Tags. This only works because we are in the asset viewer.
        if (tags.albums) {
            trackArgs.Albums = tags.albums?.map(a => a.id);
        }

        trackEvent('UPLOAD', trackArgs);

        // Clear State
        dispatch(dispatchClearState('[ASSET] Search Asset', 'items'));


        // Redirect On Complete
        const albumPath = `/library/${id}/album/${tags.albums[0].id}`;
        dispatch(push(albumPath));
    }


    const title = (storeLibraries?.activeItem) ? 'Upload to ' + storeLibraries?.activeItem?.name : ('Upload to ' + TERM_LIBRARY)

    let bread = [];
    if (albumId) {
        bread = [RouteBreadCrumbs.libraries, { href: `/library/${id}`, title: 'Library' }, { href: `/library/${id}/albums`, title: TERM_ALBUM_PLURAL }]

    } else {
        bread = [RouteBreadCrumbs.libraries, { href: `/library/${id}/albums`, title: TERM_ALBUM_PLURAL }, { href: `/library/${id}`, title: TERM_RECENT }]
    }
    // Render Page
    return (
        <App title={title}
            pageNavigation={renderPageNavigation}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={bread}
        >
            {(noAccess || permissionChecked === 'notchecked') && (<NoPermissions checked={permissionChecked} />)}
            {(!noAccess && permissionChecked !== 'notchecked') && (
                <SmartContainer width="100%">
                    <br />
                    <Uploader libraryId={id} library={activeItem} albumId={albumId} album={activeAlbum} onComplete={handleUploadComplete} />
                </SmartContainer>
            )}
        </App>
    )
}